import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import Game from "./Game";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, Link, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { config, metadata } from "./config";
import { WagmiProvider } from "wagmi";
import { createWeb3Modal } from "@web3modal/wagmi";
import { wagmiProjectId } from "./wagmi.config.";
import ShooterGame from "./ShooterGame";


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <App>
        <div
          style={{
            marginTop: 100,
            padding: 100,
            display: "flex",
            gap: 30,
            flexWrap: "wrap",
          }}
        >
          <div className="grid" style={{ width: 200 }}>
            <div>
              <article>
                <>Drone Master</>

                <footer>
                  {" "}
                  <a href="/games/delivery-guy">
                    <button className="outline">PLAY</button>
                  </a>
                </footer>
              </article>
            </div>
          </div>
          <div className="grid" style={{ width: 200 }}>
            <div>
              <article>
                <>Space Rock</>

                <footer>
                  {" "}
                  <a href="/games/shooter">
                    <button className="outline">PLAY</button>
                  </a>
                </footer>
              </article>
            </div>
          </div>
        </div>
      </App>
    ),
  },
  {
    path: "games/shooter",
    element: (
      <App>
        <ShooterGame />
      </App>
    ),
  },
  {
    path: "games/:id",
    element: (
      <App>
        <Game />
      </App>
    ),
  },
  
]);

createWeb3Modal({
  metadata,
  wagmiConfig: config,
  projectId: wagmiProjectId,
  // enableAnalytics: true, // Optional - defaults to your Cloud configuration
  // enableOnramp: true, // Optional - false as default
});

const root = ReactDOM.createRoot((document as any).getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <WagmiProvider config={config}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </WagmiProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
